import permissions from '../../permissions'

const INTEGRATION_PARTNER_TOKEN_LIST = [
  {
    name: 'Gerar token',
    description:
      'O token concede acesso programático aos dados das empresas vinculadas ao parceiro',
    tag: permissions.INTEGRATION_PARTNERS.CREATE_TOKEN,
  },
  {
    name: 'Revogar token',
    tag: permissions.INTEGRATION_PARTNERS.DESTROY_TOKEN,
  },
]

export default INTEGRATION_PARTNER_TOKEN_LIST
